
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import axios from "axios";

import ToolTitle from "./ToolTitle.vue";
import Customize from "./Customize.vue";
import JSON from "@/data/cliparts.json";
import { store } from "@/store";
import { makeNewClipArt } from "@/canvas-api/UserObjects/ClipArt";

interface ClipArts {
  path: string;
  name: string;
}

interface Icons {
  id: string;
  icon_url: string;
  is_active: string;
  attribution: string;
}

export default defineComponent({
  name: "ClipArt",
  components: {
    ToolTitle,
    Customize,
  },
  setup() {
    const title = ref("Clip Art");
    const clipArtImages = ref<ClipArts[]>(JSON.clipArts);
    const icons = ref<Icons[]>([]);

    const currentSearch = ref("");
    const loading = ref(false);

    const currentActiveObject = computed(() => store.getters.currentActiveObject);

    watch(currentActiveObject, (newObject) => {
      if (newObject) {
        title.value = "Customize";
      }
    });

    onMounted(() => {
      if (currentActiveObject.value && currentActiveObject.value.name === "clipArt") {
        title.value = "Customize";
      }
    });

    const handleInput = (e: { target: HTMLInputElement }) => {
      currentSearch.value = e.target.value;
    };

    const handleClick = async (search: string) => {
      loading.value = true;
      currentSearch.value = search;

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/editor/clipart/ajax.php?phrase=${currentSearch.value}`
        );

        icons.value = res.data.icons;
        loading.value = false;
      } catch (e) {
        loading.value = false;
        console.log(e);
      }
    };

    const handleSubmit = async () => {
      loading.value = true;

      if (currentSearch.value.length) {
        try {
          const res = await axios.get(
            `${process.env.VUE_APP_API_URL}/editor/clipart/ajax.php?phrase=${currentSearch.value}`
          );

          icons.value = res.data.icons;
          loading.value = false;
        } catch (e) {
          loading.value = false;
          console.log(e);
        }
      }
    };

    const clearIcons = () => {
      icons.value = [];
    };

    const addToCanvas = async (id: string) => {
      loading.value = true;

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/editor/clipart/ajax.php?icon_id=${id}`
        );

        makeNewClipArt(res.data);

        loading.value = false;
      } catch (e) {
        loading.value = false;
        console.log(e);
      }
    };

    return {
      title,
      clipArtImages,
      icons,
      currentSearch,
      loading,
      currentActiveObject,
      handleInput,
      handleClick,
      handleSubmit,
      clearIcons,
      addToCanvas,
    };
  },
});
